module.exports = __webpack_public_path__ + "img/vbet_01.8893d8db.jpg";